import { ScrollArea, Table, Text } from '@mantine/core';
import { useSearchParams } from 'react-router-dom';
import useGetExtendHistory from '../hooks/useGetExtendHistory';
import { handleChangeLocaleTime } from '../../../../../../shared/utils/time';

export default function ServiceExtensionHistory() {
  const searchParams = useSearchParams();
  const mac = searchParams[0].get('mac') || '';
  const { data } = useGetExtendHistory({ mac });
  return (
    <div>
      <Text fw={600} mb="xs">
        서비스 이용 내역
      </Text>
      <ScrollArea h={200}>
        <Table>
          <Table.Thead bg="gray.0">
            <Table.Tr>
              <Table.Th fw={400}>번호</Table.Th>
              <Table.Th fw={400}>요금제 타입</Table.Th>
              <Table.Th fw={400}>서비스 채널</Table.Th>
              <Table.Th fw={400}>수정일시</Table.Th>
              <Table.Th fw={400}>변경 담당자</Table.Th>
              <Table.Th fw={400}>비고</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {data?.data && data.data.length > 0 ? (
              data.data.map((item, index) => (
                <Table.Tr key={item.planName + item.regDt}>
                  <Table.Td>{data.total - index}</Table.Td>
                  <Table.Td>{item.planName || '직접 변경'}</Table.Td>
                  <Table.Td>{item.channel || '-'}</Table.Td>
                  <Table.Td>{handleChangeLocaleTime(item.regDt) || '-'}</Table.Td>
                  <Table.Td>{item.email || '-'}</Table.Td>
                  <Table.Td>{item.memo || '-'}</Table.Td>
                </Table.Tr>
              ))
            ) : (
              <Table.Tr>
                <Table.Td colSpan={6}>
                  <Text ta="center" size="sm">
                    데이터가 없습니다.
                  </Text>
                </Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </ScrollArea>
    </div>
  );
}
